import styled from 'styled-components';
import {Link} from 'react-router-dom';

const Button = styled(Link)`
    text-decoration: none;
    border-radius: 6px;
    background-blend-mode: multiply;
    /* Drop Shadow Style */
    box-shadow: 2px 2px 15px 2px rgba(0, 0, 0, 0.20);
    text-align: center;
    font-weight: 400;
    width: ${props => props.width ?? '7vw'};
    padding: ${props => props.padding ?? '0.5%'};
    font-size: 1vw;
    background: white;
    color: #1F3B71;
    cursor: pointer;
    margin-top: 6vh;
    font-family: Helvetica;
    @media screen and (max-width: 800px) {
        width: ${props => props.widthMobile ?? '180px'};
        font-size: 14px;
        padding: 5px;
        margin-top: 6vh;
    }
`;

export default Button;